module.exports = __webpack_public_path__ + "static/media/CHAP04-TITRE.3e819600.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Skew/img/CHAP04-TITRE.png
// module id = 301
// module chunks = 0